import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import CheckIcon from '../Icons/Check';
import s from './Checkbox.scss';
var Checkbox = /** @class */ (function (_super) {
    tslib_1.__extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.prototype.onChange = function (event) {
        this.props.onChange(event.target.checked);
    };
    Checkbox.prototype.render = function () {
        var _a = this.props, isChecked = _a.isChecked, halfChecked = _a.halfChecked, className = _a.className, disabled = _a.disabled;
        var icon = isChecked && halfChecked ? (React.createElement("div", { className: s['icon-dash'] })) : (React.createElement(CheckIcon, { className: s['icon'] }));
        return (React.createElement("label", { className: classnames(s['root'], isChecked && s['checked'], halfChecked && s['half-checked'], disabled && s['disabled'], className) },
            React.createElement("input", { type: "checkbox", checked: isChecked, disabled: disabled, onChange: this.onChange.bind(this) }),
            icon));
    };
    return Checkbox;
}(React.Component));
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map